import { useTranslation } from "react-i18next";
import { Icon } from "@/components/Icon";
import { useVersionCheck } from "@/data-hooks/useVersionCheck";

export function VersionBanner() {
  const { t } = useTranslation("components");
  const { newVersionAvailable, reload } = useVersionCheck();

  if (!newVersionAvailable) return null;

  return (
    <div className="fixed bottom-layout-medium left-1/2 z-[60] -translate-x-1/2">
      <div
        role="alert"
        className="flex items-center gap-component-large rounded-small bg-primary px-component-large py-component-medium text-sm text-primary-foreground shadow-(--shadow-overlay)"
      >
        <Icon name="info" size="smaller" />
        <span>{t("versionBanner.newVersionAvailable")}</span>
        <button
          type="button"
          onClick={reload}
          className="cursor-pointer font-semibold underline-offset-2 hover:underline"
        >
          {t("versionBanner.reload")}
        </button>
      </div>
    </div>
  );
}
